/* eslint-disable max-len */
import React from 'react';
import {IconProps} from './types';

export const BuyerClubIconSVG: React.FC<IconProps> = ({ isWithBorder }) => {
  return (
    <svg width="42" height="42">
      <g fill="none" fillRule="evenodd">
        {isWithBorder && (
          <path
            d="M37.246 0c0 2.89 1.756 4.023 3.134 4.468l.261.077.126.033.241.055.114.023.212.036.274.036.309.024.083.002v32.492c-2.89 0-4.023 1.756-4.468 3.134l-.077.261a6.125 6.125 0 0 0-.033.126l-.055.241a6.301 6.301 0 0 0-.023.114l-.036.212-.036.274-.024.309-.002.083H4.754c0-2.89-1.756-4.023-3.134-4.468l-.261-.077a6.125 6.125 0 0 0-.126-.033l-.241-.055a6.3 6.3 0 0 0-.114-.023l-.212-.036-.274-.036-.309-.024L0 37.246V4.754c2.89 0 4.023-1.756 4.468-3.134l.077-.261.033-.126.055-.241a6.3 6.3 0 0 0 .023-.114l.036-.212.036-.274.024-.309L4.754 0h32.492Zm-.782.827H5.503l-.04.237a6.454 6.454 0 0 1-.648 1.846c-.756 1.398-2 2.332-3.756 2.595l-.232.03v30.961l.237.041a6.454 6.454 0 0 1 1.846.648c1.398.756 2.332 2 2.595 3.756l.03.232h30.96l.042-.237a6.454 6.454 0 0 1 .648-1.846c.756-1.398 2-2.332 3.756-2.595l.232-.031V5.504l-.237-.041a6.454 6.454 0 0 1-1.846-.648c-1.398-.756-2.332-2-2.595-3.756l-.031-.232Z"
            fill="#CCCBCB"
            fillRule="nonzero"
          />
        )}
        <path d="M7 7h27v27H7z" />
        <path
          d="M28.778 13.714h-2.222C26.556 10.56 24.066 8 21 8c-3.067 0-5.556 2.56-5.556 5.714h-2.222C12 13.714 11 14.743 11 16v13.714C11 30.971 12 32 13.222 32h15.556C30 32 31 30.971 31 29.714V16c0-1.257-1-2.286-2.222-2.286ZM21 10.286c1.844 0 3.333 1.531 3.333 3.428h-6.666c0-1.897 1.489-3.428 3.333-3.428Zm0 11.428c-2.589 0-4.767-1.817-5.378-4.285-.189-.72.356-1.429 1.078-1.429.522 0 .944.389 1.089.914.389 1.452 1.678 2.515 3.211 2.515s2.822-1.063 3.211-2.515c.145-.525.567-.914 1.089-.914.722 0 1.256.709 1.078 1.429-.611 2.468-2.79 4.285-5.378 4.285Z"
          fill="#37763B"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};
